export default __webpack_public_path__ + "static/media/backgroundmed.f8da47e6.jpg";